import React, { Fragment } from 'react';
import { number, string, arrayOf, shape } from 'prop-types';
import Figure from 'components/Figure';
import { POST_COL_WIDTH } from 'constants/layout';
import { MQ_LARGE, MQ_MEDIUM, MQ_MIDLARGE, MQ_SMALL_ONLY } from 'constants/mq';
import { getAffiliateLinkProps } from 'util/affiliates/amazon';
import styles from './styles';

const SPONSORED = 'sponsored';

export const DEFAULT_IMAGE_DIM = 365;

function ProductTeaserListItem(props) {
  const {
    description,
    image,
    imageUrl,
    name,
    num,
    price,
    retailerName,
    salePrice,
    tags,
    total,
    url
  } = props;

  if (!name && !url) {
    return null;
  }

  const linkProps = getAffiliateLinkProps(url);

  const isSponsored = tags && tags.map(t => t.slug).includes(SPONSORED);

  return (
    <div className="ProductTeaserListItem">
      {imageUrl && (
        <Fragment>
          <a
            rel="nofollow"
            target="_blank"
            {...linkProps}
            className="ProductTeaserListItem__image"
          >
            <Figure
              alt={`Product Image: ${name}`}
              hideImageActions
              isPinnable={false}
              maxWidth={POST_COL_WIDTH}
              originalHeight={
                (image && image.originalHeight) || DEFAULT_IMAGE_DIM
              }
              originalWidth={
                (image && image.originalWidth) || DEFAULT_IMAGE_DIM
              }
              placement="inPost"
              sourceSizes={[
                {
                  media: MQ_MIDLARGE,
                  layoutWidth: {
                    value: 730,
                    units: 'px'
                  }
                },
                {
                  media: MQ_LARGE,
                  layoutWidth: {
                    value: 610,
                    units: 'px'
                  }
                },
                {
                  media: MQ_MEDIUM,
                  layoutWidth: {
                    value: 696,
                    units: 'px'
                  }
                },
                {
                  media: MQ_SMALL_ONLY,
                  layoutWidth: {
                    value: 343,
                    units: 'px'
                  }
                },
                {
                  layoutWidth: {
                    value: 100,
                    units: 'vw'
                  }
                }
              ]}
              url={imageUrl}
            />
          </a>
          <div className="ProductTeaserListItem__meta ProductTeaserListItem__counter">
            {num} / {total}
          </div>
          {isSponsored && (
            <div className="ProductTeaserListItem__meta ProductTeaserListItem__cake">
              Partner Pick
            </div>
          )}
        </Fragment>
      )}
      <div className="ProductTeaserListItem__body">
        <div className="ProductTeaserListItem__name">
          <a rel="nofollow" target="_blank" {...linkProps}>
            {name}
          </a>
        </div>

        {retailerName && (
          <div className="ProductTeaserListItem__retailer">{retailerName}</div>
        )}

        {(salePrice > 0 || price > 0) && (
          <div className="ProductTeaserListItem__price">
            ${((salePrice || price) / 100).toFixed(2)}
          </div>
        )}

        {price > 0 && salePrice > 0 && (
          <div className="ProductTeaserListItem__comparisonPrice">
            was ${(price / 100).toFixed(2)}
          </div>
        )}

        {description && (
          <div
            className="ProductTeaserListItem__description"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
      </div>

      <a rel="nofollow" target="_blank" {...linkProps}>
        <div className="ProductTeaserListItem__cta" aria-label="buy now">
          Buy Now
        </div>
      </a>

      <style jsx>{styles}</style>
    </div>
  );
}

ProductTeaserListItem.defaultProps = {
  description: undefined,
  image: undefined,
  imageUrl: undefined,
  num: undefined,
  price: undefined,
  retailerName: undefined,
  salePrice: undefined,
  tags: undefined,
  total: undefined
};

ProductTeaserListItem.propTypes = {
  description: string,
  image: shape({
    originalHeight: number,
    originalWidth: number
  }),
  imageUrl: string,
  name: string.isRequired,
  num: number,
  price: number,
  retailerName: string,
  salePrice: number,
  tags: arrayOf(
    shape({
      slug: string.isRequired
    })
  ),
  total: number,
  url: string.isRequired
};

export default ProductTeaserListItem;
